export const PAGE_TITLE = "IAIH Resources";

export const PAGE_TEXT =
  "The <b>International Association of Interpersonal Hypnotherapists (IAIH)</b> serves as the certifying and regulatory body for Interpersonal Hypnotherapists worldwide. Below is a list of essential resources provided by the IAIH:";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1V_EGU2a1wEszYcZh4Owh3RgakotbUd4V/preview";

export const FOOTER_TEXT =
  "These tools are designed to help practitioners build successful practices and deliver exceptional services to their clients.";

export const GHL_DIRECTORY_STATUS_FIELD_ID = "cDiwaCpf0NEsz0IbDW57";

export const ERROR_MESSAGES = {
  INVALID_PHONE: "Please enter a valid phone number (10-13 digits).",
  NO_CHANGES: "No changes detected. Please modify the data before saving.",
  SAVE_FAILED: "Failed to save the data",
};

export const SNACKBAR_MESSAGES = {
  EDIT_SUBMITTED: "Edit submitted. It will take effect once approved.",
  SUBMISSION_RECEIVED:
    "Your submission has been received. You will appear in the database once approved.",
};

export const MULTI_VALUE_FIELDS = [
  "specialities",
  "experience",
  "education",
  "certifications",
  "languages",
  "memberships",
  "instituteCertifications",
];

export const RESOURCE_PAGE_DATA = [
  {
    id: 13,
    title: "Sign Up for the IAIH Member Directory.",
    openModal: true,
    link: true,
  },
  {
    id: 12,
    title: "IAIH Member Directory",
    link: "https://www.instituteofhypnotherapy.com/iaih-directory/",
  },
  {
    id: 1,
    title: "Code of Ethics Document",
    link: "https://www.instituteofhypnotherapy.com/iaih-code-of-ethics/",
  },
  {
    id: 2,
    title: "Scope of Practice Assessment Document",
    link: "https://www.instituteofhypnotherapy.com/wp-content/uploads/2024/06/IAIH-Scope-of-Practice-Assessment-Protocols.pdf",
  },
  {
    id: 3,
    title: "Hypnosis State Laws",
    link: "https://www.instituteofhypnotherapy.com/iaih-hypnosis-law/",
  },
  {
    id: 4,
    title: "Law and Legislative Efforts",
    link: "https://www.instituteofhypnotherapy.com/iaih-legal-efforts/",
  },
  {
    id: 5,
    title: "Liability Insurance",
    link: "https://www.instituteofhypnotherapy.com/iaih-liability-insurance/",
  },
  {
    id: 6,
    title: "HIPAA Compliance",
    link: "https://www.instituteofhypnotherapy.com/iaih-hipaa-compliance/",
  },
  {
    id: 7,
    title: "Professional Intake and Disclosure Forms",
    link: "https://www.instituteofhypnotherapy.com/iaih-professional-forms/",
  },
  {
    id: 8,
    title: "Conferences",
    link: "https://www.instituteofhypnotherapy.com/iaih-2025-conference-landing-page/",
  },
  {
    id: 9,
    title: "Continuing Education Units (CEUs)",
    link: "https://www.instituteofhypnotherapy.com/ceu/",
  },
  {
    id: 10,
    title: "Certification Renewal",
    link: "https://www.instituteofhypnotherapy.com/iaih-membership/",
  },
  {
    id: 11,
    title: "Hypnotherapy Research",
    link: "https://www.instituteofhypnotherapy.com/hypnotherapy-research/",
  },
];
